module.exports = __webpack_public_path__ + "files/257d16321fb04c7a8198748823043540.png";